var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.my_question !== []
    ? _c("div", { staticClass: "row pad-top-1" }, [
        _c("div", {
          staticClass: "col-3",
          domProps: {
            innerHTML: _vm._s(_vm.my_question.survey_monkey_question_text)
          }
        }),
        _vm._v(" "),
        _c("div", { staticClass: "col-4" }, [
          _vm._v("\n    " + _vm._s(_vm.clean_choices) + "\n  ")
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-2" }, [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.my_question.local_name,
                expression: "my_question.local_name"
              }
            ],
            staticClass: "form-control questionlocalname",
            attrs: {
              type: "text",
              placeholder: "Measure/Name",
              minlength: "1",
              required: ""
            },
            domProps: { value: _vm.my_question.local_name },
            on: {
              change: function($event) {
                _vm.selectionMade()
              },
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.$set(_vm.my_question, "local_name", $event.target.value)
              }
            }
          })
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-1 clickable" }, [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.topic_to_boolean,
                expression: "topic_to_boolean"
              }
            ],
            attrs: { type: "checkbox", id: _vm.checkbox1id },
            domProps: {
              checked: Array.isArray(_vm.topic_to_boolean)
                ? _vm._i(_vm.topic_to_boolean, null) > -1
                : _vm.topic_to_boolean
            },
            on: {
              change: [
                function($event) {
                  var $$a = _vm.topic_to_boolean,
                    $$el = $event.target,
                    $$c = $$el.checked ? true : false
                  if (Array.isArray($$a)) {
                    var $$v = null,
                      $$i = _vm._i($$a, $$v)
                    if ($$el.checked) {
                      $$i < 0 && (_vm.topic_to_boolean = $$a.concat([$$v]))
                    } else {
                      $$i > -1 &&
                        (_vm.topic_to_boolean = $$a
                          .slice(0, $$i)
                          .concat($$a.slice($$i + 1)))
                    }
                  } else {
                    _vm.topic_to_boolean = $$c
                  }
                },
                function($event) {
                  _vm.selectionMade()
                }
              ]
            }
          }),
          _vm._v(" "),
          _c("label", { attrs: { for: _vm.checkbox1id } }, [
            _vm._v(_vm._s(_vm.topic_to_boolean ? "Yes" : "No"))
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-1 clickable" }, [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.score_to_boolean,
                expression: "score_to_boolean"
              }
            ],
            attrs: { type: "checkbox", id: _vm.checkbox2id },
            domProps: {
              checked: Array.isArray(_vm.score_to_boolean)
                ? _vm._i(_vm.score_to_boolean, null) > -1
                : _vm.score_to_boolean
            },
            on: {
              change: [
                function($event) {
                  var $$a = _vm.score_to_boolean,
                    $$el = $event.target,
                    $$c = $$el.checked ? true : false
                  if (Array.isArray($$a)) {
                    var $$v = null,
                      $$i = _vm._i($$a, $$v)
                    if ($$el.checked) {
                      $$i < 0 && (_vm.score_to_boolean = $$a.concat([$$v]))
                    } else {
                      $$i > -1 &&
                        (_vm.score_to_boolean = $$a
                          .slice(0, $$i)
                          .concat($$a.slice($$i + 1)))
                    }
                  } else {
                    _vm.score_to_boolean = $$c
                  }
                },
                function($event) {
                  _vm.selectionMade()
                }
              ]
            }
          }),
          _vm._v(" "),
          _c("label", { attrs: { for: _vm.checkbox2id } }, [
            _vm._v(_vm._s(_vm.score_to_boolean ? "Yes" : "No"))
          ])
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "col-1" },
          [
            _vm.my_question.has_comments > 0
              ? _c("font-awesome-icon", { attrs: { icon: "check" } })
              : _vm._e()
          ],
          1
        )
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-9566b06e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9566b06e","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/QuestionItem.vue
// module id = null
// module chunks = 